import * as React from 'react';

import { Input } from '@/components/TailwindComponents/base/Input/Input';
import { cn } from '@/components/TailwindComponents/lib/utils';

export interface NumberInputProps
  extends Omit<React.ComponentProps<'input'>, 'type'> {
  /** Whether to hide the spinner buttons (up/down arrows) */
  hideSpinner?: boolean;
}

const NumberInput = React.forwardRef<HTMLInputElement, NumberInputProps>(
  ({ className, hideSpinner = false, ...props }, ref) => {
    return (
      <Input
        type="number"
        className={cn(
          hideSpinner &&
            '[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-moz-number-spin-button]:appearance-none',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);

NumberInput.displayName = 'NumberInput';

export { NumberInput };
